module.exports = __webpack_public_path__ + "static/media/kaple-varhany.1c1a320d.jpg";